// extracted by mini-css-extract-plugin
export var content = "PartnersBlock-module--content--CMNK4";
export var partners_btn = "PartnersBlock-module--partners_btn--iCqeq";
export var partners_more_btn = "PartnersBlock-module--partners_more_btn--MgzjM";
export var partners_btn_title = "PartnersBlock-module--partners_btn_title--NoVhh";